import type { DesignVersion } from '@fluentui-copilot/react-provider';
import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type CitationSlots = {
  /**
   * The root slot.
   */
  root: NonNullable<Slot<'a'>>;
};

/**
 * Citation Props
 */
export type CitationProps = ComponentProps<Partial<CitationSlots>> &
  DesignVersion & {
    /**
     * HREF to the associated `Reference`.
     */
    referenceHref?: string;

    /**
     * Whether the citation is a block citation and has no built in margins.
     * Citations are inline by default with margins to separate them from inline text.
     */
    block?: boolean;
  };

/**
 * State used in rendering Citation
 */
export type CitationState = ComponentState<CitationSlots> &
  Required<Pick<CitationProps, 'block' | 'designVersion'>> & {
    isPopoverLocked: boolean;
  };
